export default __webpack_public_path__ + "static/media/living-room1.1e28c553.jpg";